<template>
  <div :style="tag('span')?'':'width: 100%;height:100%;'" class="ag-grid-column-edit">
    <!-- textConverter 文本自定义转换函数-->
    <span
      v-if="tag('span')"
      :class="attrs.classFunc? attrs.classFunc(params) : ''"
      :style="attrs.style||''"
    >{{ attrs.textConverter? attrs.textConverter(text||params.data[field],params.data) : (text||params.data[field]) }}</span>
    <div v-else-if="tag('el-input')">
      <el-input
        v-if="isEdit()"
        v-model="params.data[field]"
        :class="attrs.classFunc? attrs.classFunc(params) : ''"
        @change="onChange"
      />
      <span v-else>{{ params.data[field] }}</span>
    </div>
    <div
      v-else-if="tag('el-input-number')"
    >
      <el-input-number
        v-if="isEdit()"
        v-model="params.data[field]"
        :controls="false"
        :precision="precision"
        :min="min"
        :max="max"
        :style="attrs.style||'width:100%'"
        :class="attrs.classFunc? attrs.classFunc(params) : ''"
        @change="onChange"
      />
      <!--  showStyle 查看状态下的样式  -->
      <span v-else :style="attrs.showStyle||''">{{ params.data[field] }}</span>
    </div>
    <el-checkbox
      v-else-if="tag('el-checkbox')"
      v-model="params.data[field]"
      :disabled="!isEdit()"
      :true-label="typeof attrs.trueLabel ===undefined?true:attrs.trueLabel"
      :false-label="typeof attrs.falseLabel ===undefined?false:attrs.falseLabel"
      @change="onChange"
    >{{ text }}</el-checkbox>
    <el-select
      v-else-if="tag('el-select')"
      v-model="params.data[field]"
      :filterable="filterable"
      :allow-create="allowCreate"
      :disabled="!isEdit()"
      :default-first-option="true"
      :class="attrs.classFunc? attrs.classFunc(params) : ''"
      @change="onChange"
    >
      <el-option
        v-for="(item,index) in (attrs.optionsCBFunc?attrs.optionsCBFunc(params):options)"
        :key="index"
        :label="optionField.labelFunc(item)"
        :value="item[optionField.value]"
      />
    </el-select>
    <ag-grid-advance-select
      v-else-if="tag('cargo-advance-select')"
      ref="agGridAdvanceSelect"
      v-model="params.data[field]"
      :can-edit="isEdit()"
      :select-type="selectType"
      :field="field"
      :allow-create="allowCreate"
      :method-params="selectMethodParams"
      :data-filter-function="selectedDataFilterFunc"
      :tag-name="tagName"
      :tag-value="tagValue"
      :attrs="attrs"
      :clearable="clearable"
      :full-options="fullOption"
      @change="(p)=>{params.data[field] = p.value;onChange(p)}"
    />
    <el-checkbox
      v-else-if="tag('el-checkbox2')"
      v-model="params.data[field]"
      :disabled="!isEdit()"
      @change="onChange()"
    >{{ text }}</el-checkbox>
    <cargo-english-words-input
      v-else-if="tag('cargo-english-words-input')"
      v-model="params.data[field]"
      :disabled="!isEdit()"
      :style="attrs.style||'width:100%'"
      @change="onChange"
    />
    <cargo-date-time-field-input
      v-else-if="tag('cargo-date-time-field-input')"
      v-model="params.data[field]"
      :disabled="!isEdit()"
      @change="onChange"
    />
    <cargo-cell-select
      v-else-if="tag('cargo-cell-select')"
      ref="cargoCellSelect"
      v-model="params.data[field]"
      :full-options="fullOption"
      :option-field="optionField"
      :field="field"
      :edit="isEdit()"
      @cbChange="onChange"
    />
    <cargo-cell-input
      v-else-if="tag('cargo-cell-input')"
      v-model="params.data[field]"
      :field="field"
      :edit="isEdit()"
      :attrs="attrs||{}"
      :row-data="params.data"
      :class="attrs.classFunc? attrs.classFunc(params) : ''"
      @change="onChange"
    />
    <so-no-render
      v-else-if="tag('so-no-render')"
      :value="params.data[field]"
      :divider="attrs.divider"
    />
    <router-and-print
      v-else-if="tag('router-and-print')"
      key="routerAndPrint"
      :data="params.data"
      :field="field"
      :use-route="attrs.useRoute"
      :use-print="attrs.usePrint"
      :route-name="attrs.routeName"
      :route-param-keys="attrs.routeParamKeys"
      :route-title="attrs.routeTitle"
      :route-permissions="attrs.routePermissions"
      :extra-route-params="attrs.extraRouteParams"
      :extra-route-data="attrs.extraRouteData"
      :print-method="()=>attrs.printMethod(params.data[field])"
    />
    <multi-router-and-print
      v-else-if="tag('multi-router-and-print')"
      key="multiRouterAndPrint"
      :use-route="attrs.useRoute"
      :use-print="attrs.usePrint"
      :data="params.data"
      :field="field"
      :jump-method="attrs.jumpMethod"
      :print-method="()=>attrs.printMethod(params.data[field])"
    />
    <span v-else>{{ params.value }}</span>
  </div>
</template>

<script>
import agGridAdvanceSelect from './agGridAdvanceSelect'
import CargoCellSelect from '@/components/Cargo/Common/cargoCellSelect'
import CargoCellInput from '@/components/Cargo/Common/cargoCellInput'
import CargoEnglishWordsInput from '@/components/Cargo/Common/cargoEnglishWordsInput'
import CargoDateTimeFieldInput from '@/components/Cargo/Common/cargoDateTimeFieldInput'
import SoNoRender from '@/components/Cargo/Common/soNoRender'
import RouterAndPrint from '@/components/Cargo/Common/routerAndPrint'
import MultiRouterAndPrint from '@/components/Cargo/Common/multiRouterAndPrint'
import ColumnUtils from '@/utils/ColumnUtils'
import * as NumberUtils from '@/utils/NumberUtils'

export default {
  name: 'AgGridColumnEdit',
  components: {
    CargoDateTimeFieldInput,
    CargoEnglishWordsInput,
    agGridAdvanceSelect,
    CargoCellSelect,
    CargoCellInput,
    SoNoRender,
    RouterAndPrint,
    MultiRouterAndPrint
  },
  props: {
    args: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ColumnUtils,
      originalValue: '', // 原来的值
      field: '',
      custom: {},
      // isEdit: false,
      // tag: '',
      attrs: {},
      text: '',
      precision: undefined,
      min: undefined,
      max: undefined,
      options: [],
      optionField: {
        lable: '',
        value: ''
      },
      selectType: '',
      selectMethodParams: {},
      selectedDataFilterFunc: null,
      tagName: '',
      tagValue: '',
      clearable: true,
      selectObj: null,
      valueChanged: undefined,
      filterable: false,
      allowCreate: false
    }
  },
  computed: {
    curValue() {
      if (!this.params || !this.params.data) {
        return
      }
      return this.params.data[this.field]
    },
    fullOption() {
      const { attrs } = this
      if (attrs.cellSelectAttrs) {
        if (attrs.cellSelectAttrs.fullOptionsCBFunc) {
          return attrs.cellSelectAttrs.fullOptionsCBFunc(this.params)
        }
        return attrs.cellSelectAttrs.fullOptions
      }
      return null
    }
  },
  watch: {
    curValue(newVal, old) {
      if (newVal === old) {
        return
      }
      if (this.tag('cargo-advance-select')) {
        const el = this.$refs['agGridAdvanceSelect']
        if (!el.$refs.advanceSelect) {
          this.originalValue = newVal
        }
      }
      if (this.tag('cargo-cell-select')) {
        const el = this.$refs['cargoCellSelect']
        if (!el.$refs.elSelect) {
          this.originalValue = newVal
        }
      }
    }
  },
  created() {
    if (!this.params && this.args) {
      this.params = this.args
    }
    if (!this.params.data) {
      return
    }

    this.field = this.params.colDef.field || ''
    // 原始值设置
    this.originalValue = this.params.data[this.field]
    const custom = this.params.colDef.custom
    this.custom = custom
    // this.isEdit = custom.isEdit || false
    // console.log('自定义 单元格 编辑 field', this.field)
    // this.tag = custom.tag
    if (typeof custom.attrs === 'function') {
      const funcResult = custom.attrs(this.params)
      if (funcResult && typeof funcResult === 'object') {
        this.attrs = funcResult
      } else {
        this.attrs = {}
      }
    } else {
      this.attrs = custom.attrs || {}
    }
    this.text = custom.text || ''
    this.precision = custom.precision
    this.min = custom.min
    this.max = custom.max
    this.options = custom.options || []
    this.optionField = custom.optionField || {}
    if (this.options.length > 0 && !this.optionField.labelFunc) {
      this.optionField.labelFunc = (item) => item[this.optionField.label]
    }
    this.selectType = custom.selectType || ''
    this.selectMethodParams = custom.selectMethodParams || {}
    this.selectedDataFilterFunc = custom.selectedDataFilterFunc || null
    this.tagName = custom.tagName || ''
    this.tagValue = custom.tagValue || ''
    this.clearable = custom.clearable
    this.valueChanged = custom.valueChanged
    this.filterable = custom.filterable || false
    this.allowCreate = custom.allowCreate || false
    // console.log('field=============', this.field)
  },
  mounted() {
    this.$el.addEventListener('paste', this.cellPaste)
  },
  beforeDestroy() {
    this.$el.removeEventListener('paste', this.cellPaste)
  },
  methods: {
    tag(name) {
      let tagName = this.custom.tag
      if (this.attrs.tagCBFunc) {
        // 动态tag 自定义的回调处理函数
        tagName = this.attrs.tagCBFunc(this.params)
      }
      return tagName === name
    },
    isEdit() {
      let editable = this.custom.isEdit || false
      if (this.attrs.isEditCBFunc) {
        // 是否可编辑的回调处理函数
        editable = this.attrs.isEditCBFunc(this.params)
      }
      return !!editable
    },
    onChange(p) {
      console.log('change', p)
      if (typeof this.valueChanged === 'function') {
        const value = this.params.data[this.field]
        // todo-shengsheng  Desc: el-checkbox2 可以剔除，el-checkbox通过配置便可以支持
        if (this.tag === 'el-checkbox2') {
          // value = value ? 1 : 0
        }
        // 回传对象数据
        const replyData = {
          data: this.params.data,
          field: this.field,
          colId: this.params.colDef.colId,
          value,
          originalValue: this.originalValue
        }
        console.log('replyData', replyData)
        if (this.tag('cargo-advance-select') || this.tag('cargo-cell-select')) {
          // 高级下拉，有场景需要回传对象
          replyData.selectObj = p
        }
        this.valueChanged(replyData)
        // 原始值设置
        this.originalValue = this.params.data[this.field]
      }
    },
    cellPaste(e) {
      if (!this.isEdit()) {
        return
      }
      if (this.custom.multiplePaste) {
        try {
          const pastedText = e.clipboardData.getData('text')
          if (typeof pastedText === 'string') {
            const nodes = this.params.api.getModel().rowsToDisplay
            const cell = this.params.api.getFocusedCell()
            // 统一处理换行符，将 \r\n 和 \r 都转换为 \n
            const normalizedText = pastedText.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
            const lines = normalizedText.trimEnd().split('\n')
            this.params.data[this.field] = this.toCoverPaste(lines[0], this.custom.multiplePaste)
            this.onChange(this.params.data[this.field])
            for (let i = 1; i < lines.length; i++) {
              const line = this.toCoverPaste(lines[i], this.custom.multiplePaste)
              const curNode = nodes[cell.rowIndex + i]
              if (!curNode || !curNode.data) {
                break
              }
              const originalValue = curNode.data[this.field]
              curNode.data[this.field] = line
              if (typeof this.valueChanged === 'function') {
                this.valueChanged({
                  data: curNode.data,
                  field: this.field,
                  colId: this.params.colDef.colId,
                  value: line,
                  originalValue
                })
              }
            }
            e.preventDefault()
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    toCoverPaste(value, { isUppercase = false, isTrim = false, maxLength, isNumber = false, precision, min } = {}) {
      if (isUppercase) {
        value = value.toUpperCase()
      }
      if (isTrim) {
        value = value.trim()
      }
      if (maxLength > 0) {
        value = value.slice(0, maxLength)
      }
      if (isNumber) {
        // 复制A12.45NABC12进去，要变成12.4512。 需要保留数字以及小数点
        if (value) {
          value = String(value).replace(/[^\d.]/g, '')
        }
        value = Number(value) || 0
        if (typeof precision === 'number') {
          value = NumberUtils.ToFixed2(value, precision)
        }
        if (typeof min === 'number') {
          value = Math.max(value, min)
        }
      }
      return value
    }
  }
}
</script>

<style lang="scss">
  .ag-grid-column-edit{
    .el-input--mini .el-input__inner {
      height: 23px!important;
    }
  }
</style>
